import { LayoutType, withLayout } from 'src/hocs/withLayout'

import { WebPortalUsers } from './webPortalUsers'

const WrappedWebPortalUsers = withLayout(LayoutType.NoPadding, WebPortalUsers)

export { WrappedWebPortalUsers as WebPortalUsers }
